import { useState, useEffect } from 'react'
import { useChatStore } from '@/stores/useChatStore'

interface NotificationIndicatorProps {
  className?: string
}

export default function NotificationIndicator({ className = "" }: NotificationIndicatorProps) {
  const [totalUnread, setTotalUnread] = useState(0)
  const conversations = useChatStore((state: any) => state.conversations)

  useEffect(() => {
    const total = conversations.reduce((sum: number, conv: any) => sum + (conv.unreadCount || 0), 0)
    setTotalUnread(total)
  }, [conversations])

  if (totalUnread === 0) {
    return null
  }

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      {totalUnread <= 99 ? (
        <span className="bg-red-500 text-white text-xs font-medium px-2 py-1 rounded-full min-w-[20px] text-center">
          {totalUnread}
        </span>
      ) : (
        <span className="bg-red-500 text-white text-xs font-medium px-2 py-1 rounded-full min-w-[20px] text-center">
          99+
        </span>
      )}
    </div>
  )
}
